import { isChatShellContainer } from "./containerRouteMeta";
import { supportsUnifiedNativeMainShell } from "./nativeMultiTabShellGate";

/** 原生主壳 WebView 下标（Brief/Invest/Plan 共用） */
export const SHELL_NATIVE_MAIN_TAB_INDEX = 0;

/** 原生 Chat modal 常驻 WebView 下标（统一主壳） */
export const SHELL_NATIVE_CHAT_TAB_INDEX = 1;

declare global {
  interface Window {
    /** 新版 App 可选注入，仅作调试/遥测；门控以 {@link supportsUnifiedNativeMainShell} build 为准。 */
    __EDGEN_UNIFIED_MAIN_SHELL__?: boolean;
  }
}

/**
 * 当前是否应走「统一主壳」Web 分支（Brief/Invest/Plan 单 WebView）。
 * 以 {@link supportsUnifiedNativeMainShell}（build 门控）为准，不依赖原生 JS 注入。
 */
export function isUnifiedNativeMainShell(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return supportsUnifiedNativeMainShell();
}

/** 当前文档是否在统一主壳下的 Chat WebView（shell-tab-1）。 */
export function isUnifiedNativeChatShell(): boolean {
  return isChatShellContainer();
}
